import React, { useCallback } from 'react';
import FormInput from 'components/Input/FormInput';

interface IPriceTypeField {
	changePriceType: (value: string) => void;
}

const PriceTypeField: React.FC<IPriceTypeField> = ({ changePriceType }) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			changePriceType(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[changePriceType],
	);

	return (
		<FormInput testId="PriceTypeField" name="priceType" label="priceTypeLabel" getValueFromEvent={handleChange} />
	);
};

export default React.memo(PriceTypeField);
